import React from 'react';

const VALID_THEMES = ['light', 'dark', 'system'] as const;

export type Theme = typeof VALID_THEMES[number];
export const DEFAULT_THEME: Theme = 'light';
export type ColorScheme = 'light' | 'dark';

export interface RCThemeContextProps {
  /** A boolean value for pivoting UIs between light / dark modes.
   *
   * Returns `true` if `theme === 'dark'` or `theme === 'system' && prefers-color-scheme='dark'`.
  */
  darkMode?: boolean;
  /** A string representing the currently selected user theme.
   *
   * Note: `system` is always used by mobile app web views. Do not use this prop for light / dark UI pivots.
  */
  theme: Theme;
  updateTheme?: (newTheme: Theme) => void;
}

export const RCThemeContext = React.createContext<RCThemeContextProps>({
  darkMode: false,
  theme: null,
  updateTheme: () => {},
});

export function isValidTheme(theme: string) {
  return VALID_THEMES.includes(theme as any);
}
